import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../../../core/services/base.service';
import { DashboardSnapshot } from '../models/dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {
  constructor() {
    super('api/dashboard');
  }

  // Resumo operacional do período. Sem datas, o backend assume os últimos 30 dias.
  // integrationId filtra o painel por canal; o backend ignora um id que não é da empresa ativa.
  snapshot(from?: string, to?: string, integrationId?: number): Observable<DashboardSnapshot> {
    const params = new URLSearchParams();
    if (from) params.set('from', from);
    if (to) params.set('to', to);
    if (integrationId != null) params.set('integrationId', String(integrationId));

    const query = params.toString();
    return this.get<DashboardSnapshot>(query ? `?${query}` : '');
  }
}
